import { computed } from 'vue';
import { useStore } from 'vuex';
import type { LeadSource } from '@/api/openapi';
import type { TCandidates } from '@/components/organisms/user/leadList/filter/FilterItemCheckbox.vue';
import { useWait } from '@/composable/vue-wait';
import { key } from '@/store';

const useVuexLeadSources = () => {
  const store = useStore(key);
  const { doActionWithWait } = useWait();

  const leadSources = computed<LeadSource[]>(() => store.getters['user/leadSources'] ?? []);
  const leadSourcesCandidates = computed<TCandidates>(() => leadSources.value.map((leadSource) => ({
    label: leadSource.name,
    value: leadSource.id,
  })));
  const fetchAll = () => doActionWithWait(
    'getLeadSourcesWait',
    () => store.dispatch('user/getLeadSourcesAction'),
  );

  return {
    leadSourcesCandidates,
    fetchAll,
  };
};

export {
  useVuexLeadSources,
};
